import { render, staticRenderFns } from "./RedemptionsPage.vue?vue&type=template&id=2cb55aef&"
import script from "./RedemptionsPage.vue?vue&type=script&lang=js&"
export * from "./RedemptionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports